// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function debouncePromise<T, Args extends any[]>(
  func: (...args: Args) => Promise<T>,
  wait: number,
): (...args: Args) => Promise<T> {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return (...args: Args): Promise<T> => {
    return new Promise<T>((resolve, reject) => {
      const later = () => {
        timeout = null;
        func(...args)
          .then(resolve)
          .catch(reject);
      };

      if (timeout !== null) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(later, wait);
    });
  };
}
